export default __webpack_public_path__ + "static/media/startup-bg.d304dad8.jpg";